import React from "react";
import { NavLink } from "react-router-dom";
import { Drawer } from "@mui/material";
import { LuLayoutDashboard } from "react-icons/lu";
import { MdAssignmentAdd } from "react-icons/md";
import './DeliveryBoy.css';

const SidebarContent = ({ onClose }) => (
  <div className="db-sidebar" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
    {/* Logo */}
    <div className="db-sidebar-logo">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{
          width: 36, height: 36, borderRadius: 10,
          background: 'linear-gradient(135deg, var(--db-primary), #818cf8)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18
        }}>🚚</div>
        <div>
          <div className="db-sidebar-logo-title">
            SHAKAMBARI<span style={{ color: 'var(--db-primary)' }}>.</span>
          </div>
          <div className="db-sidebar-logo-sub">Delivery Partner</div>
        </div>
      </div>
    </div>

    {/* Navigation */}
    <nav style={{ flex: 1, padding: '8px 0' }}>
      <div className="db-nav-section-label">Main Menu</div>

      <NavLink
        to="dashboard"
        className={({ isActive }) => `db-nav-link ${isActive ? "active" : ""}`}
        onClick={onClose}
      >
        <LuLayoutDashboard /> Dashboard
      </NavLink>

      <NavLink
        to="assigned-orders"
        className={({ isActive }) => `db-nav-link ${isActive ? "active" : ""}`}
        onClick={onClose}
      >
        <MdAssignmentAdd /> Assigned Orders
      </NavLink>
    </nav>

    {/* Footer support box */}
    <div className="db-sidebar-footer">
      <p style={{ color: 'white', fontSize: 12, fontWeight: 700, margin: '0 0 4px' }}>Need Help?</p>
      <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: 11, margin: '0 0 10px', lineHeight: 1.5 }}>
        Contact support for any delivery issues.
      </p>
      <button style={{
        width: '100%', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.1)',
        color: 'rgba(255,255,255,0.8)', fontSize: 12, fontWeight: 600, padding: '7px 12px',
        borderRadius: 8, cursor: 'pointer', transition: 'all 0.2s'
      }}>
        Contact Support
      </button>
    </div>
  </div>
);

const Sidebar = ({ open, onClose }) => (
  <>
    {/* Desktop: fixed sidebar */}
    <div className="db-sidebar-desktop d-none d-md-flex">
      <SidebarContent onClose={onClose} />
    </div>

    {/* Mobile: slide-in drawer */}
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      sx={{ display: { md: 'none' } }}
      PaperProps={{ sx: { border: 'none', width: 'var(--db-sidebar-width)' } }}
    >
      <SidebarContent onClose={onClose} />
    </Drawer>
  </>
);

export default Sidebar;
